export const openGroupNameDialog = (group_name, on_ok_function) => ({
    type: 'RENAME_GROUP_DIALOG__OPEN',
    default_group_name: group_name,
    on_ok_function,
});
export const closeGroupNameDialog = () => ({
    type: 'RENAME_GROUP_DIALOG__CLOSE',
});
